<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back"/>
			<img src="@/images/center_text4.png" class="per_right_1name"/>
		</div>
		<div class="per_right_2">
			<div class="right-filter">
				<!--<el-form :inline="true" :model="form">
					<el-form-item label="作业状态：">
						<el-select v-model="form.state" placeholder="作业状态">
							<el-option :label="item.label" :value="item.value" :key="item.value" v-for='item in types'></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="作业名称：">
						<el-input v-model="form.examineName" placeholder="请输入作业名称关键词"></el-input>
					</el-form-item>
					<el-form-item>
						<div class="feedback_button" @click="onSubmit">
							<img src="@/images/zy_button.png" class="feedback_back" />
							<span>查询</span>
						</div>
					</el-form-item>
				</el-form>-->
			</div>
			<div class="task_right_bottom">
				<el-table :data="taskList" stripe style="width: 100%">
					<el-table-column prop="taskName" label="作业名称">
					</el-table-column>
					<el-table-column label="创建时间" align="center">
						<template slot-scope="scope">
							{{scope.row.createTime | spliceForTask}}
						</template>
					</el-table-column>
					<el-table-column prop="topicNum" label="题目数量" width='100' align="center">
					</el-table-column>
					<el-table-column prop="sumScore" label="总分" width='100' align="center">
					</el-table-column>
					<el-table-column prop="passScore" label="及格分" width='100' align="center">
					</el-table-column>
					<el-table-column label="操作" width='150' align="center">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="info(scope.row.taskId)" >查看结果</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="table-page">
					<el-pagination background @current-change="taskPageChange" :current-page="taskPage" :page-size="pageSize" layout="  prev, pager, next" :total="tasktotalRow">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getOurTaskList } from '@/api/task.js'
	export default {
		data() {
			return {
				//常规
				pageSize: 20,
				form: {
					examineName: '',
					state: '',
				},
				types: [{
					value: '',
					label: '全部'
				}, {
					value: '0',
					label: '已完成'
				}, {
					value: '1',
					label: '延时提交'
				}, {
					value: '2',
					label: '未完成'
				}],
				//作业
				taskPage: 1,
				tasktotalRow: 0,
				taskList: [],
			};
		},
		created() {
			this.getTaskList();
		},
		methods: {
			taskPageChange(page) {
				this.taskPage = page;
				this.getTaskList()
			},
			getTaskList() {
				var data = {
					pageSize: this.pageSize,
					page: this.taskPage
				}
				getOurTaskList(data).then(res => {
					if(res.code == 0) {
						this.tasktotalRow = res.data.totalRow;
						this.taskList = res.data.listData
					}
				})
			},
			onSubmit() {

			},
			info(taskId) {
				this.$router.push({
					name: 'taskdetails',
					query: {
						taskId: taskId
					}
				})
			},
		},
	};
</script>

<style>

</style>